import React from 'react';

const ComponentList = ({
  components,
  filters,
  onFilterChange,
  manufacturers,
  categories,
  subcategories,
  onEdit,
  onDelete,
  readOnly = false
}) => (
  <table>
    <thead>
      <tr>
        <th>
          Name
          <br />
          <input
            type="text"
            value={filters.component_name}
            onChange={e => onFilterChange('component_name', e.target.value)}
            placeholder="Filter"
          />
        </th>
        <th>
          Manufacturer
          <br />
          <select
            value={filters.manufacturer_id}
            onChange={e => onFilterChange('manufacturer_id', e.target.value)}
          >
            <option value="">All</option>
            {manufacturers.map(m => (
              <option key={m.manufacturer_id} value={m.manufacturer_id}>
                {m.manufacturer_name}
              </option>
            ))}
          </select>
        </th>
        <th>
          Category
          <br />
          <select
            value={filters.component_category_id}
            onChange={e => onFilterChange('component_category_id', e.target.value)}
          >
            <option value="">All</option>
            {categories.map(c => (
              <option key={c.component_category_id} value={c.component_category_id}>
                {c.category_name}
              </option>
            ))}
          </select>
        </th>
        <th>
          Subcategory
          <br />
          <select
            value={filters.component_subcategory_id}
            onChange={e => onFilterChange('component_subcategory_id', e.target.value)}
          >
            <option value="">All</option>
            {subcategories.map(s => (
              <option key={s.component_subcategory_id} value={s.component_subcategory_id}>
                {s.subcategory_name}
              </option>
            ))}
          </select>
        </th>
        <th>
          Description
          <br />
          <input
            type="text"
            value={filters.component_description}
            onChange={e => onFilterChange('component_description', e.target.value)}
            placeholder="Filter"
          />
        </th>
        <th>Specifications</th>
        <th>{readOnly ? 'View' : 'Actions'}</th>
      </tr>
    </thead>
    <tbody>
      {components.map(component => (
        <tr key={component.component_id}>
          <td>{component.component_name}</td>
          <td>{component.manufacturer_name}</td>
          <td>{component.category_name}</td>
          <td>{component.subcategory_name}</td>
          <td>{component.component_description}</td>
          <td>
            <pre style={{whiteSpace: 'pre-wrap', wordBreak: 'break-all'}}>
              {component.component_specifications ? JSON.stringify(component.component_specifications, null, 2) : ''}
            </pre>
          </td>
          <td>
            {!readOnly && onEdit && (
              <button onClick={() => onEdit(component)}>Edit</button>
            )}
            {!readOnly && onDelete && (
              <button 
                onClick={() => onDelete(component.component_id)}
                style={{ 
                  marginLeft: onEdit ? 8 : 0, 
                  backgroundColor: '#dc3545', 
                  color: 'white', 
                  border: 'none', 
                  borderRadius: '4px', 
                  padding: '0.25rem 0.5rem', 
                  cursor: 'pointer',
                  transition: 'background-color 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#c82333'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#dc3545'}
              >
                Delete
              </button>
            )}
            {readOnly && (
              <span style={{ color: '#666', fontStyle: 'italic' }}>View Only</span>
            )}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default ComponentList;